/* eslint-disable @typescript-eslint/no-explicit-any */
import horseApi from 'apis/horseApi'
import { links } from 'apps'
import { CLOSE_BTN, ICON_BORROW, LEVEL_UP, NEW_RECORD, VIEW_DOPING } from 'assets/images'
import { EnergyBar } from 'features/Horse/components'
import { useToggle } from 'hooks'
import { NOTIFICATION_MESSAGE } from 'i18n/constants'
import { ApiResponse, Horse, LENDING_STATUS } from 'models'
import { Fragment, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { ClassTag, Modal } from 'shared'
import MemoizedLoadImageCommon from 'shared/MemoizedImage/LoadImageCommon'
import { getGuildTag, handleAsyncRequest, hanldeHorseOwnerName } from 'utils/helper'
import HorseBodyInfo from '../HorseBodyInfo'
import VipIcon from 'features/components/VipIcon'
import HorseAvatar from 'features/Horse/components/HorseItem/HorseAvatar'
import HorseModalStyled from './styled'
import { getImageGender, getImageRegion } from 'utils/getLinkImage'

interface HorseModalProps {
  horse_id: number
  onCloseButtonClick?: () => void
  myName: string | number
  atProfile: boolean
  horseNFTNotExist?: any
}

function HorseModal({ horse_id, onCloseButtonClick, myName, atProfile, horseNFTNotExist = false }: HorseModalProps) {
  const [horse, setHorse] = useState<Horse>()
  const [isLoading, setIsLoading] = useToggle(false)
  const [firstTime, setFirstTime] = useState(0)
  const [disableRecovery, setDisableRecovery] = useState<boolean>(false)
  const { t } = useTranslation()
  const isHorseVip = horse?.msp_details?.msp;

  useEffect(() => {
    const fetchHorse = async () => {
      horseNFTNotExist(false)
      setIsLoading(true)

      const [error, horseResponse]: any = await handleAsyncRequest<ApiResponse<Horse>>(
        horseApi.getHorseDetailByTokenId({ horse_id })
      )
      
      if (error?.code === 400 && error?.message === 'Horse NFT does not exist.') {
        onCloseButtonClick
        horseNFTNotExist(true)
        return
      }

      if (horseResponse) {
        const fetchedHorse = horseResponse.data
        setHorse(fetchedHorse)
      }

      setIsLoading(false)
    }

    fetchHorse()
  }, [horse_id])

  // get time when access first room horse
  useEffect(() => {
    if (horse && horse?.remaining_time_to_next_energy > 0) {
      const start_at = horse?.remaining_time_to_next_energy
      setFirstTime(start_at)
    }
  }, [horse])

  // time waiting
  const timer = () => setFirstTime(firstTime - 1000)
  useEffect(() => {
    const id = setInterval(timer, 1000)
    if (firstTime > 0) {
      setDisableRecovery(true)
    }
    if (firstTime <= 0) {
      setDisableRecovery(false)
      clearInterval(id)
    }
    return () => clearInterval(id)
  }, [firstTime])

  const checkHorseOwner = () => {
    if (!horse?.owner) {
      if (horse?.user?.id === myName || horse?.user?.name === myName) return true
    }
    if (horse?.owner?.id === myName || horse?.owner?.name === myName) return true
    else return false
  }

  return (
    <Modal onOverlayClick={onCloseButtonClick}>
      <HorseModalStyled>
        {horse && !isLoading && (
          <Fragment>
            <button className='close-btn p-0 position-absolute' role='button' onClick={onCloseButtonClick}>
              <img src={CLOSE_BTN} alt='close' />
            </button>
            <div className='quick-view'>
              <div className='container'>
                <div className='quick-view-box position-relative'>
                  <div className='quick-view-container d-flex flex-column flex-lg-row align-items-lg-center'>
                    <div className='quick-view-left'>
                      <div className='left'>
                        <div className='name color-white font-bold d-block d-lg-none mb-4'>
                          {horse.name}
                        </div>
                        <div className='background-container mb-2'>
                          <HorseAvatar
                            horse={horse}
                            name={horse?.name}
                            avatar={horse?.avatar}
                            items={horse?.weapon_items_equipped}
                          />
                        </div>

                        <div className='energy-container'>
                          {horse?.user?.name === myName || horse?.user?.id === myName ? (
                            <EnergyBar
                              maxEnergy={horse.max_energy}
                              currentEnergy={horse.current_energy}
                              customClass='custom-energy mx-auto'
                              firstTime={firstTime}
                              disableRecovery={disableRecovery}
                            />
                          ) : (
                            ''
                          )}
                        </div>
                        {atProfile && (
                          <div className='d-flex justify-content-center'>
                            <div className='detail-btn-container align-items-center mt-4'>
                              <Link to={atProfile ? links.horse.detail(horse_id) : ''}>
                                <button className='detail-btn font-bold w-100 h-100'>
                                  <span className='color-primary'>{t(`${NOTIFICATION_MESSAGE}.details`)}</span>
                                </button>
                              </Link>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='quick-view-right'>
                      <div className='right'>
                        <div className='d-flex right-title'>
                          <div className='title'>
                            <div className='name color-white d-flex align-items-center gap-3'>
                              <div className='block-content d-flex gap-3'>
                                <div className='font-bold'> <span className='color-yellow'>{horse.guild && `[${horse.guild?.guild_tag}]`}</span> {horse.name}</div>
                                {horse.active === false ? (
                                  <div className='d-flex justify-content-left color-red font-size-20'>
                                    Disabled
                                  </div>
                                ) : (
                                  ''
                                )}
                              </div>
                              <div className='icon-gender'>
                                <MemoizedLoadImageCommon srcImg={getImageGender(horse?.gender)} />
                              </div>
                              <div className='region'>
                                <MemoizedLoadImageCommon srcImg={getImageRegion(horse?.region)} />
                              </div>
                              <div className='class__tag'>
                                <ClassTag text={horse?.racing_class ?? ''} isActive={true} />
                              </div>
                              {
                                checkHorseOwner() ?
                                  <div className='level-up'>
                                    <img src={LEVEL_UP} alt='' width={50} />
                                    <span className={`color-white text-uppercase ${horse.level.level.toString().length > 1 ? 'horse-level' : ''}`}>{horse.level.level} </span>
                                  </div> : ''
                              }
                              {(horse.own_status === LENDING_STATUS.Lending || horse.own_status === LENDING_STATUS.IN_GUILD) && horse.user ? (
                                <div className='icon-borrow'>
                                  <img src={ICON_BORROW} alt='' width={55} />
                                </div>
                              ) : (
                                ''
                              )}
                              {isHorseVip && (
                                <div className='vip-icon'>
                                  <VipIcon />
                                </div>
                              )}
                              {horse.equipped_boost_item && (
                                <img src={VIEW_DOPING} alt="" className='used-doping' />
                              )}
                              {/* new record */}
                              <div className='img_new_record'>
                                {horse?.is_new_record && (
                                  <MemoizedLoadImageCommon srcImg={NEW_RECORD} />
                                )}
                              </div>
                            </div>
                            <div className='name-user color-white text-uppercase'>
                              {t(`${NOTIFICATION_MESSAGE}.owner`)}: <span className='color-yellow'>{horse?.user && getGuildTag(horse?.user?.guild_tag)}</span> {hanldeHorseOwnerName(horse)}
                            </div>
                          </div>
                        </div>
                        <HorseBodyInfo horse={horse} customClass="custom-bottom-frame" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Fragment>
        )}
      </HorseModalStyled>
    </Modal>
  )
}

export default HorseModal
